import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { concatMap, of, Subscription, tap } from 'rxjs';
import { Organization } from '../../../models/organizations/organization.model';
import { FFUserWithRoles } from '../../../models/users/ff-user-with-roles.model';
import { AuthService } from '../../../services/auth.service';
import { CommonRoles } from '../../../models/perimitted-roles.model';
import { ReportsService } from '../../../services/reports.service';
import { SimpleReport } from '../../../../admin/models/reports/simple-report.model';
import { NgClass } from '@angular/common';
import { IconSpriteModule } from 'ng-svg-icon-sprite';
import { PopperToolTipComponent } from '../../../../popper/components/popper-tool-tip/popper-tool-tip.component';
import { RouterLink } from '@angular/router';
import { NavSubMenuDirective } from './nav-sub-menu.directive';
import { CanaccessDirective } from './canaccess.directive';
import { UserInfoComponent } from '../user-info/user-info.component';
import { NgxFloatUiPlacements } from 'ngx-float-ui';
import { ExternalLinkService } from '../../../services/external-link.service';

@Component({
  selector: 'ui-main-nav',
  templateUrl: './main-nav.component.html',
  styleUrls: ['./main-nav.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
  standalone: true,
  imports: [NgClass, IconSpriteModule, PopperToolTipComponent, RouterLink, NavSubMenuDirective, CanaccessDirective, UserInfoComponent],
  providers: [ReportsService]
})
export class MainNavComponent implements OnInit, OnDestroy {


  private mainNavSubscription = new Subscription();

  public hamburgerMenuDisplay: boolean = false;

  public userInfo: FFUserWithRoles;
  public currentOrg: Organization;
  public availableReports: any[] = [];
  public adminReports: SimpleReport[] = [];
  public mainNavPopperPlacement: NgxFloatUiPlacements = NgxFloatUiPlacements.BOTTOM;

  constructor(private authService: AuthService, private reportService: ReportsService, private externalLinkService: ExternalLinkService) {

  }

  public ngOnInit(): void {

    let userInfoAndReport$ = this.authService.userInfoEmitter.pipe(
      tap((result) => {
        this.userInfo = result;
        console.log('userInfo ', result);
        this.currentOrg = result.getCurrentOrg();
        if (this.userInfo && this.userInfo.roles && this.userInfo.roles.indexOf("Admin") > -1) {
          this.reportService.getAvailableAdminReportsBasic().subscribe(res => {
            this.adminReports = res;
          });
        }
      }),
      concatMap(() => {
        if (this.currentOrg) {
          return this.reportService.getAvailableReportsBasic(this.currentOrg.organizationId);
        }
        else {
          return of([]);
        }
      })
    ).subscribe({
      next: (reports: Array<SimpleReport>) => {
        this.availableReports = reports;
        this.mainNavSubscription.add(userInfoAndReport$);
      },
      error: (error) => {
        this.mainNavSubscription.add(userInfoAndReport$);
        console.log('Error listening for auth service user info. ' + error);
      }
    });

    this.authService.getUserInfo();
  }

  public ngOnDestroy(): void {
    if (this.mainNavSubscription) {
      this.mainNavSubscription.unsubscribe();
    }
  }

  /**
   * Update property to show/hide hamburger/X
   */
  public toggleMenuHamburger(): void {
    this.hamburgerMenuDisplay = !this.hamburgerMenuDisplay;
  }

  /**
   * Collapse the hamburger menu once focus leaves the nav altogether, so a keyboard
   * user who tabs past the last item is not left with an open menu behind them.
   * Individual sub menus handle their own focus loss in NavSubMenuDirective.
   */
  public onNavFocusOut(event: FocusEvent): void {
    if (!this.hamburgerMenuDisplay) {
      return;
    }
    //relatedTarget is where focus is heading, and is null when it lands on the body
    const nav = event.currentTarget as HTMLElement;
    if (!nav.contains(event.relatedTarget as Node)) {
      this.hamburgerMenuDisplay = false;
    }
  }

  public openLink(event: Event, url: string): void {
    event.preventDefault();
    this.externalLinkService.open(url);
  }

  /* For accessing the common roles object in the DOM */
  public get CommonRoles() {
    return CommonRoles
  }
}
